import Select from 'ol/interaction/Select';
import Modify from 'ol/interaction/Modify';
import Draw from 'ol/interaction/Draw';
import GeoJSON from 'ol/format/GeoJSON';

import DragInteraction from './modules/drag-interaction';

export function setupDebug(dataVectorLayer, map) {
	const modifySelect = new Select({
		layers: [dataVectorLayer], // arrowLayer
		wrapX: false,
	});
	const modifyInteraction = new Modify({
		features: modifySelect.getFeatures(),
	});
	const dragInteraction = new DragInteraction({
		layers: [dataVectorLayer], // does not work yet // arrowLayer
	});

	map.getInteractions().extend([
		modifySelect,
		dragInteraction,
		modifyInteraction,
	]);

	let draw = null;
	let featureIdCounter = 0;

	//window.arrowLayer = arrowLayer;
	window.dataVectorLayer = dataVectorLayer;

	window.drawFeature = function (featureId, featureProperties) {
		featureId = featureId || 'neu-' + featureIdCounter++;
		featureProperties = featureProperties || {
			name: featureId,
			description: 'description of ' + featureId,
			website: '',
		};

		if (draw) {
			return;
		}

		modifySelect.setActive(false);

		draw = new Draw({
			source: dataVectorLayer.getSource(),
			type: 'Polygon',
		});

		map.addInteraction(draw);
		draw.on('drawend', (e) => {
			e.feature.setId(featureId);
			e.feature.setProperties(featureProperties);

			map.removeInteraction(draw);
			draw = null;
			modifySelect.setActive(true);
		});
	};

	window.copyFeature = function (featureId, featureProperties) {
		featureId = featureId || 'neu-' + featureIdCounter++;
		featureProperties = featureProperties || {
			name: featureId,
			description: 'description of ' + featureId,
			website: '',
		};

		const features = modifySelect.getFeatures().getArray();
		if (features.length === 1) {
			const newFeature = features[0].clone();
			newFeature.setId(featureId);
			newFeature.setProperties(
				Object.assign(newFeature.getProperties(), featureProperties)
			);
			dataVectorLayer.getSource().addFeature(newFeature);
			modifySelect.getFeatures().clear();
		} else {
			console.error('No feature selected!');
		}
	};

	window.deleteFeature = function () {
		const features = modifySelect.getFeatures().getArray();
		if (features.length === 1) {
			dataVectorLayer.getSource().removeFeature(features[0]);
			modifySelect.getFeatures().clear();
		} else {
			console.error('No feature selected!');
		}
	};

	window.setFeatureProp = function (value, prop) {
		prop = prop || 'newProp';

		const features = modifySelect.getFeatures().getArray();
		if (features.length === 1) {
			features[0].set(prop, value);
			modifySelect.getFeatures().clear();
		} else {
			console.error('No feature selected!');
		}
	};

	window.setFeatureName = function (name) {
		window.setFeatureProp(name, 'name');
	};

	window.getGeoJsonByFeatureId = function (featureId) {
		return new GeoJSON().writeFeature(
			dataVectorLayer.getSource().getFeatureById(featureId)
		);
	};

	window.getGeoJson = function () {
		const collection = new GeoJSON().writeFeaturesObject(
			dataVectorLayer.getSource().getFeatures(),
			{
				featureProjection: 'EPSG:3857',
				dataProjection: 'EPSG:4326',
			}
		);
		collection.features = collection.features.map((f) => ({
			id: f.id,
			fill: f.fill,
			geometry: f.geometry,
		}));
		return JSON.stringify(collection, null, 2);
	};
}
